import { change } from 'redux-form';
import get from 'lodash-es/get';

import store from 'app/store';
import {
  FieldsEnum,
  FormsEnum,
  GenderEnum,
  ModelPathEnum,
} from 'app/shared/enums';
import { getModelPathByField } from 'app/shared/helpers/getModelPathByField';
import { changeFieldValue } from 'app/services/businessFunctionHelpers';
import {
  getBirthdayStringByPesel,
  isPeselValid as isPeselValidFunc,
} from 'app/services/pesel.service';
import { QuotationService } from 'app/services/quotation.service';
import { QuotationActions } from 'app/store/data/quotation';

export function setBirthdateAndGenderByPesel(
  initialRun: boolean,
  pesel: number,
  formName: FormsEnum,
  birthdateField: FieldsEnum,
  genderField?: FieldsEnum
) {
  const quotation = store.getState().quotation;
  const isPeselValid = isPeselValidFunc('' + pesel);
  const birthday = getBirthdayStringByPesel('' + pesel) || '';

  if (!isPeselValid) {
    return;
  }

  if (!initialRun) {
    const modelPath = getModelPathByField(birthdateField);

    modelPath && QuotationService.update(quotation.id, modelPath, birthday);
    changeFieldValue(birthdateField, birthday, formName);
  }

  if (genderField) {
    const isMan = +pesel.toString()[9] % 2;
    const gender = isMan ? GenderEnum.Man : GenderEnum.Woman;

    if (!initialRun) {
      const modelPath = getModelPathByField(genderField);
      modelPath &&
        store.dispatch(
          QuotationActions.setQuotationQuestion(modelPath, gender)
        );
      changeFieldValue(genderField, gender, formName);
    }

    const modelPath = getModelPathByField(genderField);

    if (
      modelPath &&
      (get(quotation, modelPath) !== gender || gender === GenderEnum.Man)
    ) {
      const { id: quotationId } = store.getState().quotation;

      switch (genderField) {
        case FieldsEnum.OwnerGender:
          QuotationService.update(
            quotationId,
            ModelPathEnum.MainOwnerFamilyName,
            null
          );
          store.dispatch(
            change(FormsEnum.CalculationForm, FieldsEnum.OwnerFamilyName, null)
          );
          store.dispatch(
            change(
              FormsEnum.CheckoutForm,
              FieldsEnum.CheckoutOwnerFamilyName,
              null
            )
          );
          break;
        case FieldsEnum.Coowners1Gender:
          QuotationService.update(
            quotationId,
            ModelPathEnum.Coowners1FamilyName,
            null
          );
          store.dispatch(
            change(
              FormsEnum.CalculationForm,
              FieldsEnum.Coowners1FamilyName,
              null
            )
          );
          store.dispatch(
            change(
              FormsEnum.CheckoutForm,
              FieldsEnum.CheckoutCoowners1FamilyName,
              null
            )
          );
          break;
        case FieldsEnum.Coowners2Gender:
          QuotationService.update(
            quotationId,
            ModelPathEnum.Coowners2FamilyName,
            null
          );
          store.dispatch(
            change(
              FormsEnum.CalculationForm,
              FieldsEnum.Coowners2FamilyName,
              null
            )
          );
          store.dispatch(
            change(
              FormsEnum.CheckoutForm,
              FieldsEnum.CheckoutCoowners2FamilyName,
              null
            )
          );
          break;
      }
    }
  }
}
